module.exports = __webpack_public_path__ + "img/TNT_LOGO_W_NAME.3b46cc74.png";